import { generalKey } from '../../config/pageConfig';
import ProductNav from '../../common/ProductNav';
import { useProductStore } from '../../ProductProvider';
import EU_Product from './EU_Product';
import NA_Product from './NA_Product';
import NA from './NA';
import JP_Product from './JP_Product';
import JP_Product_V2 from './JP_Product_V2';
import getLocal from '@/app/utils/getLocal';
import EfScrollAni from '@/efscrollani';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import './css/index.scss';

export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale = 'us' } = getLocal();
    const { pageStatus } = useProductStore();
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey[0] });

    const IS_NA_SITE = ['ca', 'us'].includes(locale);
    const IS_JP_SITE = locale === 'jp';
    const IS_EU_SITE = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className="page-product">
            <ProductNav activeTab={'Product'} buyLink={productMsg.buyLink} />
            {/* {IS_NA_SITE && <NA_Product />} */}
            {IS_NA_SITE && !['statusA'].includes(pageStatus) && <NA />}
            {IS_NA_SITE && ['statusA'].includes(pageStatus) && <NA_Product />}
            {IS_EU_SITE && <EU_Product />}

            {IS_JP_SITE && ['statusA', 'statusB'].includes(pageStatus) && <JP_Product />}
            {IS_JP_SITE && !['statusA', 'statusB'].includes(pageStatus) && <JP_Product_V2 />}
        </div>
    );
}
